import { gql } from '@apollo/client'
import React from 'react'

import { stocksClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useModalData } from '../../../../components/modals/ModalsContext'

const Context = React.createContext([])
const { Provider } = Context
export const useStockItemState = () => React.useContext(Context)
export const useStockItem = () => useStockItemState()?.stockItem

const QUERY = gql`
  query StockItem($id: ID) {
    stockItem(id: $id) {
      id
      name
      amount
      totalAmount
      warningAmount
      criticalAmount
      enabled
      insertedAt
      updatedAt
      qrcodes {
        id
        activated
        bucketId
        data
        recordId
        type
        updatedAt
        insertedAt
      }
      documents {
        id
        src
      }
    }
  }
`

const StockItemLoader = ({ children }) => {
  const { id } = useModalData() || {}
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: stocksClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default StockItemLoader
